import {InitPage} from "../../index";
import axios from "axios";

class ManufacturingSoToZoneCount {
    constructor() {
        let searchParam = $("#search").val();
        if (typeof searchParam !== 'undefined') {
            if(searchParam) {
                axios.get(`so_to_zone_process_count_async.json`, { params: { search: searchParam } }).then((resp) => this.displayData(resp.data));
            } else {
                axios.get(`so_to_zone_process_count_async.json`).then((resp) => this.displayData(resp.data));
            }
        }
        if($("#step2SoProcessIDs").length > 0) {
            const soIds = $("#step2SoProcessIDs").data('ids');
            axios.get(`so_to_zone_step_2_display_percentages.json`, { params: { so_ids: soIds } }).then((resp) => this.displayStep2Data(resp.data));
        }
    }

    displayData(resp: any) {
        $("#count_step_1").text(resp.step_1);
        $("#count_step_2").text(resp.step_2);
        $("#count_step_3").text(resp.step_3);
        $("#count_step_4").text(resp.step_4);
        $("#count_step_5").text(resp.step_5);
        $("#count_step_6").text(resp.step_6);
        $("#count_step_7").text(resp.step_7);
    }

    // TODO: Check this out
    displayStep2Data(resp: any) {
        resp.forEach(element => {
            $(`#so_process_${element.id}_can_be_fullfilled`).text(`${element.qty_fulfilment}%`);
            $(`#so_process_${element.id}_progress`).text(`${element.hard_allocation}%`);
        });
    }
}

export function LoadPage() {
    InitPage("so_to_zone_processes steps", () => {
        const c = new ManufacturingSoToZoneCount();
    });
}
